<template>
  <div v-if="!collapse" class="region-picker">
    <div class="region-picker-label">区域筛选</div>
    <el-cascader
      v-model="localValue"
      :options="options"
      :props="cascaderProps"
      placeholder="全部地区"
      size="small"
      clearable
      filterable
      popper-class="sidebar-region-cascader"
      @change="handleChange"
    />
    <div class="region-picker-scope">当前：<b>{{ scopeLabel }}</b></div>
  </div>
</template>

<script>
import { getCascaderOptions } from '@/utils/region-data'

export default {
  name: 'RegionPicker',
  props: {
    collapse: { type: Boolean, default: false }
  },
  data() {
    return {
      options: getCascaderOptions(),
      cascaderProps: { checkStrictly: true, expandTrigger: 'hover', emitPath: true },
      localValue: this.$store.state.region.selected.slice()
    }
  },
  computed: {
    scopeLabel() {
      return this.$store.getters.regionScopeLabel
    },
    storeSelected() {
      return this.$store.state.region.selected
    }
  },
  watch: {
    storeSelected(val) {
      // 外部清空或修改时，同步本地 v-model
      this.localValue = (val || []).slice()
    }
  },
  methods: {
    handleChange(val) {
      this.$store.dispatch('region/setRegion', val || [])
    }
  }
}
</script>

<style lang="scss" scoped>
.region-picker {
  padding: 12px 14px 14px;
  background: #1f2d3d;
  border-bottom: 1px solid #2a3a4f;

  .region-picker-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
    letter-spacing: 1px;
  }

  .region-picker-scope {
    font-size: 11px;
    color: #909399;
    margin-top: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    b {
      color: #ffd04b;
      font-weight: 600;
    }
  }

  ::v-deep .el-cascader {
    width: 100%;
  }

  ::v-deep .el-input__inner {
    background-color: #263445;
    border-color: #344a63;
    color: #bfcbd9;

    &::placeholder {
      color: #6d7c8c;
    }
  }
}
</style>
